export default function EditOtherResourcesDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  bcpSharedModelService
) {
  const vm = this;

  vm.handleClose = _handleClose;
  vm.handleSave = _handleSave;
  vm.validateContactResource = _validateContactResource;
  vm.validateURL = _validateURL;

  /** **************************************************
   * Event Handlers
   */

  function _handleClose() {
    _closeDialog();
  }

  function _handleSave() {
    if ($scope.bcpEditOtherResourceForm.$invalid) {
      return false;
    }
    loaderService.showViewLoader = true;
    return bcpSharedModelService.saveOtherResource(vm.otherResource)
      .then(() => {
        loaderService.showViewLoader = false;
        alerts.success('The Other External Resource has been saved successfully.');
        $rootScope.$broadcast('refreshOtherResources');

        // Old way of refreshing the entire BCP Plan
        // $rootScope.$broadcast('refreshBCPAssessments');
        $rootScope.$broadcast('refreshNotifications');
        _closeDialog();
      })
      .catch(() => {
        loaderService.showViewLoader = false;
        alerts.error('There was an error saving the Other Resource.');
      });
  }

  function _validateContactResource() {
    return vm.otherResource.supportPhone === '' && vm.otherResource.website === '';
  }

  /** **************************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editOtherResourcesDialog);
  }

  function _validateURL() {
    // eslint-disable-next-line max-len
    if (vm.otherResource.website.startsWith('http://') || vm.otherResource.website.startsWith('https://')) {
      vm.scope.bcpEditOtherResourceForm.website.$invalid = false;
      vm.scope.bcpEditOtherResourceForm.website.$error = '';
      vm.isValid = true;
    } else {
      vm.scope.bcpEditOtherResourceForm.website.$invalid = true;
      vm.scope.bcpEditOtherResourceForm.website.$error = { pattern: true };
    }
  }
}

EditOtherResourcesDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpSharedModelService'
];
